import { AFTERNIC_PLIDS } from '../shared/constants';
import { add_params_to_url } from './urls';

export const external_url_map = {
  TURN_OFF_2STEP_VERIFICATION: 'https://www.{host}/help/turn-off-two-step-verification-7628',
  DID_NOT_RECEIVE_2STEP_CODE: 'https://www.{host}/help/i-didnt-receive-my-two-step-verification-code-7564',
  USE_SECURITY_KEY_TO_SIGN_IN: 'https://www.{host}/help/log-in-with-a-security-key-31905',
  BREACHED_PASSWORD_INFO: 'https://www.{host}/help/a-40049',
  WEBMAIL_SALES_PAGE: 'https://www.{host}/email/professional-business-email',
};

export const brand_external_url_map = {
  TURN_OFF_2STEP_VERIFICATION: 'https://{web_app}.{host}/domain-help',
  DID_NOT_RECEIVE_2STEP_CODE: 'https://{web_app}.{host}/domain-help',
  USE_SECURITY_KEY_TO_SIGN_IN: 'https://{web_app}.{host}/domain-help',
};

export const brand_url_only_plids = [497036, 1001836];

export function get_web_app(host, plid) {
  let web_app = 'www';
  if (AFTERNIC_PLIDS.includes(Number(plid))) {
    const hostRegex = /^(?<env>[^-]*)-.*$/gm;
    const match = hostRegex.exec(host);
    if (match) {
      const env = match.groups.env;
      // don't want to break this logic while introducing the rule - please fix if touching this code
      // eslint-disable-next-line eqeqeq
      if (env == 'dev' || env == 'test') {
        web_app = 'www.int';
      }
    }
  }

  return web_app;
}

export function brand_aware_url(url, plid, include_prog_id = false) {
  if (Number(plid) !== 1) {
    const params = { plid };
    if (include_prog_id) {
      params.prog_id = window.ux && window.ux.data && window.ux.data.progId ? window.ux.data.progId : plid;
    }
    return add_params_to_url(url, params);
  }
  return url;
}

export function build_url(key, host, plid, include_prog_id = false) {
  let branded_url = '';
  if (brand_url_only_plids.includes(Number(plid)) && brand_external_url_map.hasOwnProperty(key)) {
    const url = brand_external_url_map[key].replace('{host}', host);
    const web_app = get_web_app(host, plid);
    branded_url = url.replace('{web_app}', web_app);
  } else if (external_url_map.hasOwnProperty(key)) {
    const url = external_url_map[key].replace('{host}', host);
    branded_url = brand_aware_url(url, plid, include_prog_id);
  }

  if (branded_url) {
    return branded_url;
  }
  console.warn(`No url found for key ${key}`);
  return '';
}
